import React, {useContext, useEffect, useRef} from "react";
import { useSearchParams } from "react-router-dom";
import { AppContext } from "../../context/AppContext";

export function ResetPasswordComponent() {
  const {
    services: {
      serviceAuth
    }
  } = useContext(AppContext);

  const resetPasswordRef = useRef<HTMLElement | null>(null);
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const email = searchParams.get("email");

  useEffect(() => {
    (window as any).DIA_RESET_PASSWORD_SERVICE = serviceAuth;
    const el = resetPasswordRef.current as any;
    if (!el) return;

    if (token) { el.token = token; el.setAttribute('token', token); }
    if (email) { el.email = email; el.setAttribute('email', email); }
   }, [token, email, serviceAuth]);


  return <dia-reset-password
    ref={resetPasswordRef}
    custom-service-forgot-password="passwordForget"
    custom-service-reset-password="passwordReset"
  ></dia-reset-password>;
}
